



import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import OrderDeliveryIng from './OrderDeliveryIng.vue';
@Component({
  components: { AdminIframe, OrderDeliveryIng },
})
export default class OrderDeliveringIframe extends Vue {
  private get remoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();
    console.log(this.$route.query);
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/order/delivering' + '?' + queryString;
    return src;
  }
}
